import React, { useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";

const SignPadModal = (props) => {

    let pad = useRef(null); // reference to signature pad
    


    const singCompleteHandler = () => {
        if (pad.isEmpty() === false) {
            props.hasSigned(true)
            let x = pad.toDataURL('png').split(",")[1];
            props.signature(prev => ({...prev, 
                partner: ({...prev.partner, x_file_vollmacht: x})
            }));
            props.setShow(false);
        }
    }

    return (
            <div>
                <Modal fullscreen size="lg" show={props.show}>
                    <Modal.Header closeButton onHide={() => props.setShow(false)}>
                        <Modal.Title>Unterschrift</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="padContainer">
                            <div className="sigContainer">
                                <SignatureCanvas ref={(ref) => { pad = ref }} penColor="black" backgroundColor="rgba(0,0,0,0)"
                                    canvasProps={{ className: 'sigCanvas', }}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="danger"
                            onClick={() => pad.clear()}>Löschen
                        </Button>
                        <Button
                            className="btn-energo"
                            onClick={() => singCompleteHandler()}>Bestätigen
                        </Button>
                    </Modal.Footer>
                </Modal>

                </div>
    )
}

export default SignPadModal;